import { render, staticRenderFns } from "./BidView.vue?vue&type=template&id=8139ad7a&scoped=true&"
import script from "./BidView.vue?vue&type=script&lang=js&"
export * from "./BidView.vue?vue&type=script&lang=js&"
import style0 from "./BidView.vue?vue&type=style&index=0&id=8139ad7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8139ad7a",
  null
  
)

export default component.exports